import { MouseBlocker } from "@lib/titan2/dist/game/control/MouseBlocker";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { Logger } from "@lib/titan2/dist/util/log/Logger";
import { SpineUtil } from "@lib/titan2/dist/util/view/SpineUtil";
import { gsap } from "gsap";
import { SlingoEvent } from "../../../controller/event/SlingoEvent";
import { TweenConstants } from "../constant/TweenConstants";
import { SlingoStyle } from "../style/SlingoStyle";
import { AbstractGameView } from "./AbstractGameView";
/**
 * FullHouse.ts
 */
export class FullHouse extends AbstractGameView {
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
    }
    addEventListeners() {
        super.addEventListeners();
        this.registerGame(SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_TWO, this.handlePlayFullHouse);
    }
    removeEventListeners() {
        super.removeEventListeners();
        this.unregisterGame(SlingoEvent.FULL_HOUSE_ANIMATION_PHASE_TWO);
    }
    create() {
        super.create();
        this.createMouseBlocker();
    }
    createMouseBlocker() {
        if (this.uiProperties.mouseBlockerProperties) {
            this.mouseBlocker = new MouseBlocker(this.landscapeProperties.mouseBlockerProperties, this.portraitProperties?.mouseBlockerProperties);
        }
    }
    showOverlay() {
        if (this.mouseBlocker) {
            this.mouseBlocker.alpha = 0;
            this.addChildAt(this.mouseBlocker, 0);
            gsap.to(this.mouseBlocker, { duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION, alpha: 1 });
        }
    }
    hideOverlay() {
        this.mouseBlocker && gsap.to(this.mouseBlocker, {
            duration: TweenConstants.DEFAULT_OVERLAY_FADE_DURATION,
            alpha: 0,
            onComplete: () => {
                this.removeChild(this.mouseBlocker);
            }
        });
    }
    postCreate() {
        super.postCreate();
        this.reset();
        Logger.addObjectRef(this, "FullHouse");
    }
    reset() {
        this.hideOverlay();
    }
    handlePlayFullHouse() {
        this.animation = TitanSpine.createSpine(this, this.landscapeProperties.animationProperties, this.portraitProperties?.animationProperties);
        this.dispatchGame(SlingoEvent.FULL_HOUSE_APPEAR);
        this.showOverlay();
        SpineUtil.play(this.animation, [SlingoStyle.FULL_HOUSE_IN_LANDSCAPE, SlingoStyle.FULL_HOUSE_IN_PORTRAIT], () => {
            SpineUtil.play(this.animation, [SlingoStyle.FULL_HOUSE_LOOP_LANDSCAPE, SlingoStyle.FULL_HOUSE_LOOP_PORTRAIT], () => {
                SpineUtil.play(this.animation, [SlingoStyle.FULL_HOUSE_OUT_LANDSCAPE, SlingoStyle.FULL_HOUSE_OUT_PORTRAIT], this.handleAnimationComplete, this);
            });
        });
    }
    handleAnimationComplete() {
        this.reset();
        this.dispatchGame(SlingoEvent.FULL_HOUSE_ANIMATION_COMPLETE);
    }
}
//# sourceMappingURL=FullHouse.js.map